import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    position: 'relative',

    paddingLeft: '$sm',
    paddingRight: '$sm',
    '@lg': {
        height: '80vh',
        minHeight: 700,
        paddingLeft: 'calc(3 * $colWidth)',
        paddingRight: 'calc(3 * $colWidth)',
    },
})

export const ContentWrapper = styled('div', {
    width: 'calc(6 * $colWidth)',
    '@lgDown': {
        width: '100%',
        marginTop: '-$sm',
        textShadow: '2px 2px 2px rgba(0, 0, 0, 0.7)',
    },
})

export const NumbersWrapper = styled('div', {
    width: 'calc(7.5 * $colWidth)',
    '@lgDown': {
        width: '100%',
        margin: '0 auto',
        paddingTop: '$xs',
    },
})

export const ImageWrapper = styled('div', {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100vh',
    width: 'calc(17* $colWidth)',
    zIndex: -1,
    overflow: 'hidden',
    '@lgDown': {
        position: 'relative',
        marginLeft: '-$sm',
        width: '100vw',
        height: 'auto',
    },
})
